module.exports = __webpack_public_path__ + "img/jd.f0fcfbfd.jpg";